var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isPopinDisplayed,
          expression: "isPopinDisplayed",
        },
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: { callback: _vm.popin_reservationCommentDisplayed_callback },
          expression:
            "{ callback: popin_reservationCommentDisplayed_callback }",
        },
      ],
      staticClass: "popin-modal centered",
      attrs: { id: "reservation-comment" },
    },
    [
      _c("div", { staticClass: "popin-container" }, [
        _c(
          "div",
          {
            staticClass: "popin-closure",
            on: { click: _vm.popin_reservationCommentClosed },
          },
          [_c("div", { staticClass: "arrow" }, [_vm._v("X")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "popin-closure-responsive",
            on: { click: _vm.popin_reservationCommentClosed },
          },
          [_c("div", { staticClass: "arrow" }, [_vm._v("X")])]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "popin" }, [
          _c("div", { staticClass: "popin-content" }, [
            _vm.reservation
              ? _c("div", { staticClass: "popin-content-container" }, [
                  _c("p", [
                    _vm._v(
                      "Réservation au nom de " +
                        _vm._s(_vm.reservation.first_name) +
                        " " +
                        _vm._s(_vm.reservation.last_name)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "En date du " +
                        _vm._s(_vm.reservation.creneau_day) +
                        "/" +
                        _vm._s(_vm.reservation.creneau_month) +
                        "/" +
                        _vm._s(_vm.reservation.creneau_year) +
                        " pour " +
                        _vm._s(_vm.scenario.room_label)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [_vm._v("Commentaire")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formReservationComment_comment,
                          expression: "formReservationComment_comment",
                        },
                      ],
                      attrs: {
                        maxlength: "255",
                        disabled: _vm.request_isProcessing,
                      },
                      domProps: { value: _vm.formReservationComment_comment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.formReservationComment_comment =
                            $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-submit" }, [
                    _c("span", { staticClass: "form-error" }, [
                      _vm._v(_vm._s(_vm.formReservationComment_error)),
                    ]),
                    _vm._v(" "),
                    _vm.request_isProcessing
                      ? _c("button", [_c("Loader_Mini")], 1)
                      : _c(
                          "button",
                          { on: { click: _vm.enregistrer_buttonClicked } },
                          [_vm._v("Enregistrer")]
                        ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }